import React from 'react';

function Footer() {
  
    return (
      <footer className="bg-warning p-2 d-flex justify-content-center text-light bg-dark">Made by Sergey Vozika | 2022</footer>
    );
  
  }

export default Footer;